export default "__VITE_ASSET__RBXB3JHY__"